import { TypedDocumentNode, gql } from "@apollo/client";

interface ServiceData {
  serviceByType: ServiceByTypeInterface[];
}

export enum ServiceType {
  IS_POPULAR = 1,
  IS_CERTIFICATION_PROGRAM = 2,
  IS_SKILL_BASED_COURSES = 3,
}

export const GET_SERVICE_BY_TYPE: TypedDocumentNode<ServiceData, ServiceType> =
  gql`
    query GetServiceByType($serviceType: ServiceType!, $countryCode: String) {
      serviceByType(serviceType: $serviceType, country_code: $countryCode) {
        name
        isPopular
        rating
        id
        isSkillBasedCourses
        isCertificationProgram
        serviceImage
        service_image
        serviceIcon
        numberOfLearners
        slug
        accreditation_url
        accreditation_logo
        accreditation_name
        serviceTrainingDays
        sellingPriceNumber
        currency
        serviceContents {
          name
          isHtmlDescription
        }
        serviceLevel
      }
    }
  `;
